const HELP_CENTER_WINDOW_NAME = 'webfleetHelpCenterWindow'
const FALLBACK_HELP_CENTER_BASE_URL = 'https://help.webfleet.com'

const helpCenterCategories = {
    CONTACT: 'contact',
    DRIVERS: 'drivers',
    FEEDBACK: 'feedback',
    GET_STARTED: 'get-started',
    FAQ: 'faq',
    HELP: 'help',
    MODULE: 'module',
    MODULE_RECOMMENDATION: 'module-recommendation',
    MODULE_VIDEO: 'module-video',
    NEW: 'new',
    SEARCH: 'search',
    VIDEOS: 'videos'
}

/**
 * Generates link to existing helpcenter page.
 *
 * @param {string} baseUrl - WEBFLEET help center base URL provided from database setting `WebfleetHelpCenterBaseUrl`.
 * @param {string} locale - requires 5 character locale code.
 * @param {string} module - Simple string or React Router location object to track the link origin.
 * @param {string} contentId - Help center target content id.
 * @returns {string} The URL to the customer help center.
 *
 * @see https://help.webfleet.com
 */
function createContentIdHelpUrl(baseUrl, locale, module, contentId) {
    const helpCenterBaseUrl = baseUrl || FALLBACK_HELP_CENTER_BASE_URL
    const safeLocale = locale || 'en-GB'

    return `${helpCenterBaseUrl}/?locale=${safeLocale}&context=${module}&contentid=${contentId}`
}

export { HELP_CENTER_WINDOW_NAME, helpCenterCategories, createContentIdHelpUrl }
